import { render, staticRenderFns } from "./AccountDetails.vue?vue&type=template&id=1c38778c&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"
import style0 from "./AccountDetails.vue?vue&type=style&index=0&id=1c38778c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38778c",
  null
  
)

export default component.exports